import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';

export default class HotelBenchmarkInsightUpsellController extends Controller {
  @service declare access: Services['access'];

  get isTrialUpsell(): boolean {
    return this.access.hasBenchmarkInsightTrialUpsell;
  }
}
